import { Injectable } from '@angular/core';
import {Router} from "@angular/router";

// PF Not used yet. Could replace Navigate.js
@Injectable({
  providedIn: 'root'
})
export class RoutingService {

  constructor(private router: Router) {
    (window as any).NG_SHARED_ROUTING_SERVICE = this;
  }

  reload() {
    this.router.navigate([this.router.url]);
  }

  refresh() {
    this.router.navigate([this.router.url]);
  }
}
